import { Fragment } from "react";
import dayjs from "dayjs";
import { IRequest } from "./types";
import styles from "./styles.module.scss";
import { JsonView } from "../shared/json-view/JsonView";

export const ResponseParser = ({ data }: { data: IRequest }) => {
  let body: any = {};
  let headers: any = {};
  try {
    body =
      typeof data?.body == "string"
        ? data.body
          ? JSON.parse(data?.body)
          : {}
        : data.body;
    headers =
      typeof data?.headers == "string"
        ? data?.headers
          ? JSON.parse(data?.headers as unknown as string)
          : {}
        : data.headers;
  } catch (e) {}

  return (
    <div className={styles.container}>
      <span>
        <b>time:</b>
        <label>{dayjs(data.time).format("HH:mm:ss - MM/DD/YYYY")}</label>
      </span>
      <div className={styles.divider} />
      {headers &&
        Object.keys(headers)?.length === 0 &&
        typeof data.headers === "string" && <span>{data.headers}</span>}
      {headers &&
        Object.keys(headers).map((key) => {
          return (
            <span key={key}>
              <b>{key}:</b>
              <label className={styles.customLabel}>{headers[key]}</label>
            </span>
          );
        })}
      {data.body && (
        <Fragment>
          <div className={styles.divider} />
          <div>
            <JsonView data={body} />
          </div>
        </Fragment>
      )}
    </div>
  );
};
